import * as _ from 'lodash';
import { actionTypes } from 'redux-form';

import * as types from './types';
import { LOGIN_FORM_NAME } from '../../common/FormEnum';

const INITIAL_STATE = {
  changedForm: [],
  changedElement: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.RESET_DIRTY:
      return { ...INITIAL_STATE };

    case actionTypes.CHANGE: {
      //log that this form changed
      //if it has not already been logged
      const formName = action.meta.form;
      if (
        !state.changedForm.includes(formName) &&
        formName !== LOGIN_FORM_NAME
      ) {
        return {
          ...state,
          changedForm: [...state.changedForm, formName],
        };
      }

      return state;
    }

    case types.FORCE_DIRTY_STATE: {
      const currentValues = _.cloneDeep(state.changedElement);

      currentValues.push({
        id: `FORCED-${action.payload.id}`,
        initialValue: 0,
        newValue: 1,
      });

      return {
        ...state,
        changedElement: currentValues,
      };
    }

    case types.SET_ELEMENT_CHANGED: {
      const { id, initialValue, newValue } = action.payload;
      const copiedData = _.cloneDeep(state.changedElement);
      const existing = _.find(copiedData, { id });

      if (existing) {
        //exists - modify
        existing.newValue = newValue;
      } else {
        //doesn't exist add
        copiedData.push({ id, initialValue, newValue });
      }

      return {
        ...state,
        changedElement: copiedData,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/dirtyTracking/reducer.js